import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives';

const skeletonTemplateCardContainerStyles = css({
	position: 'relative',
	borderRadius: '6px',
	width: '368px',
	minHeight: '400px',
	boxShadow: '0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 2px 0px rgba(9, 30, 66, 0.25)',
	overflow: 'hidden',

	boxSizing: 'border-box',
	transition: 'box-shadow 0.35s',
	'&:hover': {
		boxShadow: '0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)',
	},
	'@media (min-width: 48rem) and (max-width: 63.99rem)': {
		width: '320px',
	},
	'@media (max-width: 47.99rem)': {
		width: '320px',
	},
});

const skeletonTemplateCardImageStyles = css({
	flex: '0 200px',
	overflow: 'hidden',
	'@media (max-width: 47.99rem)': {
		flex: '0 200px',
	},
	backgroundSize: 'cover',
	backgroundRepeat: 'no-repeat',
	flexShrink: 0,
});

const skeletonTemplateCardInfoStyles = css({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	overflow: 'hidden',
	height: '100%',
	alignSelf: 'stretch',
});

const skeletonTemplateCardInfoWrapper = css({
	flex: 1,
	backgroundColor: '#FFF',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	padding: '24px 24px 16px 24px',
	borderRadius: '6px',
	height: '100%',
});

const skeletonTemplateCardTitleStyles = css({
	height: '30px',
	backgroundColor: '#EBECF0',
	borderRadius: '3px',

	[media.below.md]: {
		height: '28px',
	},
});

const skeletonTemplateCardDescriptionContainerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
});

const skeletonTemplateCardDescriptionStyles = css({
	height: '20px',
	backgroundColor: '#EBECF0',
	margin: 0,
	borderRadius: '3px',
});

const skeletonTemplateCardInfoAuthorStyles = css({
	height: '20px',
	width: '40%',
	backgroundColor: '#EBECF0',
	borderRadius: '3px',
});

const PERCENTS = [10, 5, 25, 15, 20];

export const SkeletonTemplateCard = ({
	background,
	index,
}: {
	background?: string;
	index: number;
}) => {
	const titleLine = 40 + (PERCENTS[index % PERCENTS.length] ?? 0) + '%';
	const descLine1 = 100 - (PERCENTS[index % PERCENTS.length] ?? 0) + '%';
	const descLine2 = 60 + (PERCENTS[index % PERCENTS.length] ?? 0) + '%';
	return (
		<div css={skeletonTemplateCardContainerStyles}>
			<div css={skeletonTemplateCardInfoStyles}>
				<div css={[skeletonTemplateCardImageStyles, css({ background })]} />
				<div css={skeletonTemplateCardInfoWrapper}>
					<div css={skeletonTemplateCardTitleStyles} style={{ width: titleLine }} />
					<div css={skeletonTemplateCardDescriptionContainerStyles}>
						<div css={skeletonTemplateCardDescriptionStyles} style={{ width: descLine1 }} />
						<div css={skeletonTemplateCardDescriptionStyles} style={{ width: descLine2 }} />
					</div>
					<div css={skeletonTemplateCardInfoAuthorStyles} />
				</div>
			</div>
		</div>
	);
};
